import { createAction, props } from '@ngrx/store';
import { RuleData } from '@app/Shared/interfaces/iRules';

// Load Rules Actions
export const loadRules = createAction('[RULES] LOAD_RULES');
export const loadRulesSuccess = createAction('[RULES] LOAD_RULES_SUCCESS', props<{ rules: RuleData[] }>());
export const loadRulesFailure = createAction('[RULES] LOAD_RULES_FAILURE', props<{ error: string }>());

// Create Rule Actions
export const createRule = createAction('[RULES] CREATE_RULE', props<{ ruleData: RuleData }>());
export const createRuleSuccess = createAction('[RULES] CREATE_RULE_SUCCESS', props<{ rule: RuleData }>());
export const createRuleFailure = createAction('[RULES] CREATE_RULE_FAILURE', props<{ error: string }>());

// Update Rule Actions
export const updateRule = createAction('[RULES] UPDATE_RULE', props<{ key: number; ruleData: RuleData }>());
export const updateRuleSuccess = createAction('[RULES] UPDATE_RULE_SUCCESS', props<{ rule: RuleData }>());
export const updateRuleFailure = createAction('[RULES] UPDATE_RULE_FAILURE', props<{ error: string }>());

// Delete Rule Actions
export const deleteRule = createAction('[RULES] DELETE_RULE', props<{ key: number }>());
export const deleteRuleSuccess = createAction('[RULES] DELETE_RULE_SUCCESS', props<{ key: number }>());
export const deleteRuleFailure = createAction('[RULES] DELETE_RULE_FAILURE', props<{ error: string }>());

// Select Rule Actions
export const selectRule = createAction('[RULES] SELECT_RULE', props<{ rule: RuleData | null }>());
export const clearSelectedRule = createAction('[RULES] CLEAR_SELECTED_RULE');

// Filter Rules by Rule Type
export const filterRulesByRuleType = createAction('[RULES] FILTER_RULES_BY_RULE_TYPE', props<{ ruleTypeKey: number | null }>());
